import React from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import { ShowDialogParams } from '@/store/dialog/types';
import { Typography } from '@dev/ee-components';
import { CheckoutsStripeAccountUpdate } from '@/store/checkoutsStripeAccount/actions';
import { UpdateDialog } from '@/store/dialog/actions';

interface PublishModalProps {
    popBackCallback: () => void;
}

export const usePublishModalParams = ({ popBackCallback }: PublishModalProps): {
    getPublishModalProps: (isConnectInitiated: boolean) => ShowDialogParams;
} => {
    const dispatch = useDispatch<any>();
    const { t } = useTranslation();
    
    const onClose = (): void => {
        popBackCallback();
    };

    const getPublishModalProps = (isConnectInitiated: boolean): ShowDialogParams => {
        const onConfirmClick = (): void => {
            dispatch(UpdateDialog({ isLoading: true }));
            dispatch(CheckoutsStripeAccountUpdate(window.location.href, window.location.href))
                .then(() => {
                    dispatch(UpdateDialog({ isLoading: false }));
                })
                .catch(() => {
                    dispatch(UpdateDialog({ isLoading: false }));
                });
        };

        const body = (
            <Typography variant="body1">{t('checkoutpaymentsettingsmodalcontent')}</Typography>
        );

        return {
            title: t('paymentsettings'),
            confirmLabel: isConnectInitiated ? t('finishonconnectingwithstripe') : t('connectwithstripe'),
            onClickConfirm: onConfirmClick,
            cancelLabel: t('cancel'),
            onClickCancel: onClose,
            body,
            id: 'publish-checkout-modal',
            width: '600px',
            isHiddenManually: true,
        };
    };
    return { getPublishModalProps };
};
